"use strict";
// import create from "zustand";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
// interface FilterState {
//     selectedPills: string[];
//     togglePill: (pill: string) => void;
//     resetPills: () => void;
// }
// export const store = create<FilterState>((set) => ({
//     selectedPills: [],
//     togglePill: (pill: string) =>
//         set((state) => {
//             const isSelected = state.selectedPills.includes(pill);
//             if (isSelected) {
//                 return { selectedPills: state.selectedPills.filter((p) => p !== pill) };
//             } else {
//                 return { selectedPills: [...state.selectedPills, pill] };
//             }
//         }),
//     resetPills: () => set({ selectedPills: [] }),
// }));
const zustand_1 = __importDefault(require("zustand"));
exports.store = (0, zustand_1.default)((set) => ({
    selectedPills: [],
    togglePill: (pill) => set((state) => {
        const isSelected = state.selectedPills.includes(pill);
        if (isSelected) {
            return { selectedPills: state.selectedPills.filter((p) => p !== pill) };
        }
        else {
            return { selectedPills: [...state.selectedPills, pill] };
        }
    }),
    resetPills: () => set({ selectedPills: [] }),
    setSelectedPills: (pills) => set({ selectedPills: pills }),
}));
